import { useMutation } from "@tanstack/react-query";

import { type DocumentDisposition, getDocumentFileURL } from "@/adapters/api";

export interface OpenDocumentFileInput {
	documentId: string;
	disposition: DocumentDisposition;
}

export function openDocumentURL(url: string, disposition: DocumentDisposition) {
	if (disposition === "attachment") {
		window.location.assign(url);
		return;
	}
	window.open(url, "_blank", "noopener");
}

export function useDocumentFileURL(constructionId: string | undefined) {
	return useMutation({
		mutationFn: async ({ documentId, disposition }: OpenDocumentFileInput) => {
			if (!constructionId) throw new Error("missing construction");
			const { url } = await getDocumentFileURL(
				constructionId,
				documentId,
				disposition === "attachment" ? "attachment" : undefined,
			);
			return url;
		},
		onSuccess: (url, { disposition }) => openDocumentURL(url, disposition),
	});
}
